import { useState } from 'react'

import Charts from './tabs/Charts'
import Table from './tabs/Table'
import Exeptions from './tabs/Exeptions'
import { useText } from '../../texts'

function Tabs() {
  const t = useText()
  let tabList = ['timetable', 'table', 'exceptions']
  const [activeTab, setActiveTab] = useState(tabList[0])

  const showTab = () => {
    switch (activeTab) {
      case 'timetable':
        return <Charts />
      case 'table':
        return <Table />
      case 'exceptions':
        return <Exeptions />
      default:
        return <Charts />
    }
  }

  return (
    <div className="analytics-tabs">
      <div className="analytics-tabs-header">
        {tabList.map((tab) => (
          <div
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`analytics-tabs-header__item ${
              tab === activeTab ? 'active' : ''
            }`}
          >
            {t(tab)}
          </div>
        ))}
      </div>
      <div className="analytics-tabs-body">{showTab()}</div>
    </div>
  )
}

export default Tabs
